<div
  class="ap-mb-spacing-5"
  [class.has-error]="errorMessages && errorMessages.invalid">
  <ap-field
    #field
    [title]="label()"
    [dpSelectedDates]="value()"
    (dpSelectedDatesChange)="onSelectedDatesChange($event)"
    (dpOnDateInvalid)="dpOnDateInvalidFn($event)"
    (onShow)="showHandler()"
    (onClose)="closeHandler()"
    [error]="!!errorMessages && errorMessages.invalid"
    [datepicker]="true"
    dpType="single"
    [dpRange]="ranged()"
    [disabled]="disabled()"
    [attachedDOM]="attachedDOM()"
    [required]="isRequired()">
    <input
      #appkitInput
      appkit-field
      [disabled]="disabled()"
      (input)="inputChange($event)" />
    @if (errorMessages && errorMessages.invalid) {
      <div class="ap-field-validation-error">
        {{ errorMessages.errorMessage }}
      </div>
    }
  </ap-field>
</div>
